import type { ReactNode } from 'react';
import {
  Modal as HeroModal, ModalContent, ModalHeader, ModalBody, ModalFooter,
} from '@heroui/react';

export interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | 'full';
  scrollBehavior?: 'inside' | 'outside';
  hideClose?: boolean;
}

/**
 * Design-system Modal. Standardises header/body/footer structure and blur
 * backdrop so feature modals only supply content. For forms, put the <form> in
 * `children` with an id and a submit Button (form=…) in `footer`.
 */
export function Modal({ isOpen, onClose, title, children, footer, size = 'md', scrollBehavior = 'inside', hideClose }: ModalProps) {
  return (
    <HeroModal isOpen={isOpen} onClose={onClose} size={size} scrollBehavior={scrollBehavior} backdrop="blur" hideCloseButton={hideClose}>
      <ModalContent>
        {title && <ModalHeader className="text-fg">{title}</ModalHeader>}
        <ModalBody>{children}</ModalBody>
        {footer && <ModalFooter>{footer}</ModalFooter>}
      </ModalContent>
    </HeroModal>
  );
}
